import { IntlProvider } from 'react-intl';

import React from 'react';

import messagesEn from './locales/en.json';
import messagesFr from './locales/fr.json';

const messages = {
    en: messagesEn,
    fr: messagesFr,
};

const LanguageProvider = ({ children, locale = 'en' }) => {
    return (
        <IntlProvider locale={locale} messages={messages[locale]}>
            {children}
        </IntlProvider>
    );
};

export default LanguageProvider;
